import {useMatch} from 'react-router-dom';

export type RootName = 'store' | 'challenge' | 'space';

export default function useRootName(): RootName {
  const isStore = useMatch('/store/*');
  const isChallenge = useMatch('/challenges/*');
  const isSpace = useMatch('/space/*');

  if (!isStore && !isChallenge && !isSpace) {
    throw new Error('Root name not found');
  }
  return isStore ? ('store' as const) : isChallenge ? ('challenge' as const) : ('space' as const);
}
